<script setup>
import { computed } from 'vue';
import BaseBubble from './Base.vue';
import AudioChip from 'next/message/chips/Audio.vue';
import { useMessageContext } from '../provider.js';

const props = defineProps({
  transcription: {
    type: String,
    default: null,
  },
});

const { attachments } = useMessageContext();

const attachment = computed(() => {
  return attachments.value[0];
});
</script>

<template>
  <BaseBubble class="bg-transparent" data-bubble-name="audio">
    <AudioChip
      :attachment="attachment"
      class="p-2 text-n-slate-12 skip-context-menu"
    />
    <div
      v-if="props.transcription"
      class="mx-2 mb-2 p-3 rounded-lg border-l-4"
      style="background-color: rgba(0, 0, 0, 0.03); border-left-color: #10b981; font-family: Inter, ui-sans-serif, system-ui, sans-serif;"
    >
      <div class="flex items-center gap-1 mb-1.5 opacity-50 text-[10px] uppercase tracking-widest font-semibold text-n-slate-11">
        <span>✨ Transcrição Gerada por IA</span>
      </div>
      <div class="text-sm leading-relaxed text-n-slate-12 italic">
        {{ props.transcription }}
      </div>
    </div>
  </BaseBubble>
</template>
